import { request } from '../../../request'
import {
  LOCALIZACAO_UNIDADES_FETCH_LOCATIONS,
  LOCALIZACAO_UNIDADES_TOGGLE_LOADING
} from './types'

const getUnidadesSigMV = async () => {
  const { data } = await request.get('/unidade-organizacional/uor-sig-mv')

  return data
}

export const actions = {
  async fetchLocalizacaoUnidades(store, payload) {
    store.commit(LOCALIZACAO_UNIDADES_TOGGLE_LOADING)

    const unidadesSigMv = await getUnidadesSigMV()
    const { data } = await request.get('/unidade-organizacional/service-uors', {
      params: {
        secretaria: payload
      }
    })

    if (data) {
      const filterEmptyMV = item => {
        return item.nome_mv.length > 0
      }

      const mapper = item => {
        const nome_mv = unidadesSigMv.find(
          subitem => subitem.nome_unidade_sigsantos === item.nome
        )

        return {
          nome_mv: nome_mv ? nome_mv.nome_unidade_mv : '',
          ...item
        }
      }

      store.commit(
        LOCALIZACAO_UNIDADES_FETCH_LOCATIONS,
        data.map(mapper).filter(filterEmptyMV)
      )
    }

    store.commit(LOCALIZACAO_UNIDADES_TOGGLE_LOADING)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/localizacao_unidades/actions.js